import React, { useEffect } from 'react';

import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { connect } from 'react-redux';
import StructureOption from '@Pages/RetroSynthesis/StructureOption/StructureOption';
import { REDUCER_KEY_STRUCTURE_OPTIONS } from '@Pages/RetroSynthesis/StructureOption/constants';
import {
  clearStateAction,
  fetchSynthesisPlannerMenuOptionsAction,
  structureOptionClearAction,
} from '@Pages/RetroSynthesis/StructureOption/actions';
import { openWith3d } from '@Containers/StructureDialog/StructureDialogAction';

const StructureOptionContainer = (
  {
    targetRect,
    data,
    optionType,
    synthesisMenuOptions,
    trackingContext,
    routeType,
    clearStateAction,
    structureOptionClearAction,
    fetchSynthesisPlannerMenuOptionsAction,
    openStructureIn3dAction,
  }) => {

  useEffect(() => {
    fetchSynthesisPlannerMenuOptionsAction();
    // DO not use this action because Angular routing mount and unmount component
    return clearStateAction;
  }, []);

  return (
    <StructureOption
      targetRect={targetRect}
      data={data}
      optionType={optionType}
      onClosed={structureOptionClearAction}
      synthesisMenuOptions={synthesisMenuOptions}
      openStructureIn3d={openStructureIn3dAction}
      trackingContext={trackingContext}
      routeType={routeType}
    />
  );
};

const mapStateToProps = (state) => {
  const { targetRect, data, optionType, synthesisMenuOptions, trackingContext, routeType } = state.get(REDUCER_KEY_RS)
    .get(REDUCER_KEY_STRUCTURE_OPTIONS);
  return {
    targetRect,
    data,
    optionType,
    synthesisMenuOptions,
    trackingContext,
    routeType,
  };
};

const mapDispatchToProps = {
  clearStateAction,
  structureOptionClearAction,
  fetchSynthesisPlannerMenuOptionsAction,
  openStructureIn3dAction: openWith3d,
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureOptionContainer);
